import type { DonationBatch } from '../types/marketPromotionP2.types';

export function getBatchNumber(batch: Pick<DonationBatch, 'legacyId' | 'batchId'>): number {
  return Math.abs(batch.legacyId ?? batch.batchId);
}
